import N8nOption from './Option.vue';

export default N8nOption;
